import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import EFunction from '../../utils/FunctionPage';
import useSwitchFunc from '../../redux/switchFunc/switchFuncAction';
import LoginPage from "./LoginPage";
import SettingsPage from "./SettingsPage";
import RegisterPage from "./RegisterPage";
import WalletPage from "./WalletPage";
import RecordsPage from "./RecordsPage";
import WinLobbyPage from "./WinLobbyPage";
import UniPlayPage from "./UniPlayPage";
import StorePage from "./StorePage";

function MainPage()
{
    const { funcId, setFunc } = useSwitchFunc();

    //===========================================================================
    const [page, setPage] = useState(<LoginPage />);

    useEffect(() => {
        componentDidMount();
        return componentWillUnmount;
    }, []);

    useEffect(() => {
        switch (funcId) {
            case EFunction.login: setPage(<LoginPage />); break;
            case EFunction.changePassword: setPage(<SettingsPage changePassword={true}/>); break;
            case EFunction.verifyPhone: setPage(<SettingsPage verifyPhone={true}/>); break;
            case EFunction.settings: setPage(<SettingsPage normalMode={true}/>); break;
            case EFunction.register: setPage(<RegisterPage />); break;
            case EFunction.wallet: setPage(<WalletPage />); break;
            case EFunction.records: setPage(<RecordsPage />); break;
            case EFunction.winLobby: setPage(<WinLobbyPage />); break;
            case EFunction.uniPlay: setPage(<UniPlayPage />); break;
            case EFunction.store: setPage(<StorePage />); break;
            default: setFunc(EFunction.login); break;
        }
    }, [funcId]);
    //===========================================================================

    function componentDidMount()
    {
        window.addEventListener('resize', onResize);
        //AppCtrl.rebuilLobbies();
        onResize();
    }

    function componentWillUnmount()
    {
        window.removeEventListener('resize', onResize);
        console.log('exit MainPage');
    }

    function onResize()
    {
        const deviceWidth = window.innerWidth;
        const deviceHeight = window.innerHeight;
        const topY = 60;

        const uiLoginPage = document.getElementById('loginPage');
        if (uiLoginPage) {
            uiLoginPage.style.top = '0px';
            uiLoginPage.style.left = '0px';
            uiLoginPage.style.width = `${deviceWidth}px`;
            uiLoginPage.style.height = `${deviceHeight}px`;
            uiLoginPage.style.overflowX = 'hidden';
            uiLoginPage.style.overflowY = 'auto';
        }

        const uiSettingsPage = document.getElementById('settingsPage');
        if (uiSettingsPage) {
            uiSettingsPage.style.top = '0px';
            uiSettingsPage.style.left = '0px';
            uiSettingsPage.style.width = `${deviceWidth}px`;
            uiSettingsPage.style.height = `${deviceHeight}px`;
            uiSettingsPage.style.overflowX = 'hidden';
            uiSettingsPage.style.overflowY = 'auto';
        }
    }

    return (        
        <div>
            {
                page
            }
        </div>
        // <Routes>
        //     <Route path='/login' element={<LoginPage />} />
        //     <Route path='/change-password' element={<SettingsPage changePassword={true} />} />
        //     <Route path='/verify-phone' element={<SettingsPage verifyPhone={true} />} />
        //     <Route path='/settings' element={<SettingsPage normalMode={true} />} />
        //     <Route path='/register' element={<RegisterPage />} />
        //     <Route path='/wallet' element={<WalletPage />} />
        //     <Route path='/records' element={<RecordsPage />} />
        //     <Route path='/lobby' element={<WinLobbyPage />} />
        //     <Route path='/play' element={<UniPlayPage />} />
        //     <Route path='/store' element={<StorePage />} />
        //     <Route path="*" element={<Navigate to='/login' replace />} />
        // </Routes>
    );
}

export default MainPage;